/**
 * Check all the observable arguments are true.
 */
import * as Rx from 'rxjs';
import { defaultIfEmpty, distinctUntilChanged, map } from 'rxjs/operators';
export function allTrue() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return Rx.combineLatest(observables.map(function (observable$) {
        return observable$.pipe(defaultIfEmpty(false));
    })).pipe(map(function (args) { return args.every(function (x) { return x; }); }), distinctUntilChanged());
}
